import { render } from "./ManageInvitation.vue?vue&type=template&id=4051062b&scoped=true"
import script from "./ManageInvitation.vue?vue&type=script&lang=js"
export * from "./ManageInvitation.vue?vue&type=script&lang=js"

import "./ManageInvitation.vue?vue&type=style&index=0&id=4051062b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4051062b"]])

export default __exports__